import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
let checkAll:boolean = false;
@Component({
  selector: 'app-second-director-declaration',
  templateUrl: './second-director-declaration.component.html',
  styleUrls: ['./second-director-declaration.component.scss']
})
export class SecondDirectorDeclarationComponent implements OnInit {
  IsBusinessDebitCard: any = sessionStorage.IsBusinessDebitCard == "true" ? false : true;
  constructor(public router: Router) { }
  onSubmit() {

    if (($("#obaoform").valid())&&(checkAll == true)) {
      this.router.navigate(['/second-director-confirm']);
    }
  }

  ngOnInit() {

    var check_bada = false;
    var check_bcda = false;
    var check_va = false;
  //var check_bdcpds = false;
    var check_bdcca = this.IsBusinessDebitCard;


    function checkTrueClickLink() {

      if ((check_bada == true) && (check_bcda == true) && (check_va == true) && (check_bdcca == true)) {
        //do something
        $("#link_error_container").css("display", "none");
        checkAll = true;
      } else {
        $("#link_error_container").html("Please view all links");
      }

    }

    $(document).ready(function () {


      $("#btn-agree").click(function () {
        checkTrueClickLink();
      });

      $("#link-bcda").click(function () {
        check_bada = true;
        checkTrueClickLink();
      });
      $("#link-bada").click(function () {
        check_bcda = true;
        checkTrueClickLink();
      });
      $("#link-va").click(function () {
        check_va = true;
        checkTrueClickLink();
      });
    //$("#link-bdcpds").click(function () {
    //  check_bdcpds = true;
    //  checkTrueClickLink();
    //});
      $("#link-bdcca").click(function () {
        check_bdcca = true;
        checkTrueClickLink();
      });




      $("#obaoform").validate({

        rules: {
          radio_declare_second: {
            required: true
          }
        },
        messages: {
          radio_declare_second: {
            required: "Please select yes or no"
          }
        },
        errorPlacement: function (error, element) {

          if (element.attr("name") == "radio_declare_second") {
            error.appendTo("#radio_declare_second_error_container");
          }

        },
        submitHandler: function (form) {

        }


      });

    });

  }


}
